import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7b02632f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Catégorie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Groupe de Taxe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Mode de prix "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom du produit "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description ", -1))
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_22 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "Conditionnement", -1))
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = {
  class: "table",
  style: {"width":"100% !important"}
}
const _hoisted_26 = { style: {"width":"100% !important"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"300px !important"} }, "Conditionnement", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Qté", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Prix de vente", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Prix Min", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Prix Max", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Coéfficié?", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_34 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { style: {"margin-bottom":"5px !important"} }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        ref: "elementForm",
        onSubmit: _ctx.addElement,
        "validation-schema": _ctx.elementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  name: "categorie",
                  modelValue: _ctx.categorieSelected,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categorieSelected) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.categorieOptions,
                      searchable: true,
                      placeholder: "Rechercher un element",
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins deux caractères"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "categorie",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  name: "groupeTaxe",
                  modelValue: _ctx.groupeTaxeSelected,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.groupeTaxeSelected) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.groupeTaxeOptions,
                      searchable: true,
                      placeholder: "Rechercher un element",
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins deux caractères"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "groupeTaxe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Field, {
                  name: "modeDePrix",
                  modelValue: _ctx.modePrixSelected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modePrixSelected) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.modePrixOptions,
                      searchable: true,
                      placeholder: "Rechercher un element",
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins deux caractères"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "modeDePrix",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, {
                  name: "libelle",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom du produit"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "libelle",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  name: "description",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la description"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("button", {
                  type: "button",
                  class: "default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addConditionnement && _ctx.addConditionnement(...args)))
                }, " + conditionnement ")
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("thead", _hoisted_26, _hoisted_34, 512), [
                    [_vShow, _ctx.showThead]
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionnements, (conditionnement, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_35, [
                          _createVNode(_component_Field, {
                            name: 'conditionnement'+index,
                            modelValue: conditionnement.conditionnement,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.conditionnement) = $event),
                            style: {"min-width":"50px !important"}
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                ref_for: true
                              }, field, {
                                options: _ctx.getFilteredOptions(index),
                                searchable: true,
                                placeholder: "Rechercher",
                                noResultText: "Aucun enregistrement trouvé",
                                noOptionsText: "Tapez au moins deux caractères"
                              }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                            ]),
                            _: 2
                          }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'conditionnement'+index,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_Field, {
                            name: 'qteCond'+index,
                            type: "text",
                            modelValue: conditionnement.qteCond,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.qteCond) = $event),
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Quantité"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'qteCond'+index,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_Field, {
                            name: 'prix'+index,
                            type: "text",
                            modelValue: conditionnement.prix,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.prix) = $event),
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Prix"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'prix'+index,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_Field, {
                            name: 'prixMin'+index,
                            type: "text",
                            modelValue: conditionnement.prixMin,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMin) = $event),
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Minumum"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'prixMin'+index,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_Field, {
                            name: 'prixMax'+index,
                            type: "text",
                            modelValue: conditionnement.prixMax,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMax) = $event),
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Maximum"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'prixMax'+index,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_Field, {
                            name: 'estCoefficier'+index,
                            type: "checkbox",
                            modelValue: conditionnement.estCoefficier,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.estCoefficier) = $event),
                            value: true,
                            "unchecked-value": false,
                            class: "form-check-input shadow-none fs-md-15 text-black"
                          }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'estCoefficier'+index,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_Field, {
                            name: 'pc_libelle',
                            type: "text",
                            modelValue: conditionnement.nomComplet,
                            "onUpdate:modelValue": ($event: any) => ((conditionnement.nomComplet) = $event),
                            class: "form-control shadow-none fs-md-15 text-black"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: 'pc_libelle',
                            class: "text-danger"
                          })
                        ], 512), [
                          [_vShow, false]
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-outline-danger",
                            onClick: ($event: any) => (_ctx.removeConditionnement(index))
                          }, "x", 8, _hoisted_36)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_37,
          _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.btntext), 1)
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}